import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconComplaintsProps } from './IconComplaints.types'
import * as Styled from './styles/IconComplaints.style'

import { nonThemeableRules } from '../../ruleSet'

const IconComplaints: FC<IconComplaintsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconComplaintsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconComplaintsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M9 13.031h6m-4.875-4a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M9.89 9.031a.39.39 0 0 1-.39.39.392.392 0 0 1-.39-.39.39.39 0 0 1 .78 0Zm0 0' vectorEffect='non-scaling-stroke' />
          <path
            d='M9.656 9.031c0 .086-.07.156-.156.156a.157.157 0 0 1-.156-.156.156.156 0 0 1 .312 0Zm5.469 0a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M14.89 9.031a.39.39 0 0 1-.39.39.392.392 0 0 1-.39-.39.39.39 0 0 1 .78 0Zm0 0' vectorEffect='non-scaling-stroke' />
          <path
            d='M14.656 9.031c0 .086-.07.156-.156.156a.157.157 0 0 1-.156-.156.156.156 0 0 1 .312 0ZM9.5 16.535l-4 3.965v-3.965'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M5.5 16.535h-1c-1.105 0-2-.898-2-2V6.56c0-1.106.895-2 2-2h17v9.976c0 1.102-.895 2-2 2h-10'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconComplaints
